import { useCallback, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { toast } from 'material-react-toastify';
import { addressesAtom } from '../atoms/Address';
import { getAddresses } from '../api/Address';
import { isTokenValid } from '../utils/Auth';

export const useAddresses = () => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useRecoilState(addressesAtom);

  const refreshAddresses = useCallback(() => {
    if (!isTokenValid()) return;

    setLoading(true);
    getAddresses()
      .then(setAddresses)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(refreshAddresses, []);

  return {
    addresses,
    loading,
    refreshAddresses,
  };
};
